export default __webpack_public_path__ + "static/media/git-pull.65ef3590.svg";